
import Vue from "vue";
import { Component, Prop, Provide, Watch } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store";

import ElementPropertiesPanel from "@/components/ElementPropertiesPanel/ElementPropertiesPanel.vue";
import Add from "@/components/Add/AddPanel.vue";
import GlobalSettingsPanel from "@/components/Settings/DocumentOrGlobalSettings/GlobalSettingsPanel.vue";
import SelectorsPanel from "@/components/Settings/Selectors/SelectorsPanel.vue";
import StructurePanel from "@/components/Structure/StructurePanel.vue";
import { PanelPosition, UIPanel } from "@/types/ui";
import HistoryAndRevisionsPanel from "@/components/HistoryAndRevisions/HistoryAndRevisionsPanel.vue";
import AppLayoutBodyPanelArea from "@/components/Reusable/AppLayout/AppLayoutBodyPanelArea.vue";
import VariablesPanel from "@/oxygen/variables/panel/VariablesPanel.vue";
import PresetsPanel from "@/components/Settings/ElementPresets/PresetsPanel.vue";
import AIPanel from "../AI/AIPanel.vue";
import OxygenElementPropertiesPanel from "@/oxygen/properties-panel/OxygenElementPropertiesPanel.vue";
import OxySelectorsPanel from "@/oxygen/classes/panel/OxySelectorsPanel.vue";

@Component({
  components: {
    OxySelectorsPanel,
    VariablesPanel,
    PresetsPanel,
    AppLayoutBodyPanelArea,
    HistoryAndRevisionsPanel,
    StructurePanel,
    ElementPropertiesPanel,
    Add,
    GlobalSettingsPanel,
    SelectorsPanel,
    AIPanel,
    OxygenElementPropertiesPanel
  }
})
export default class SidebarPanels extends Vue {
  get builderMode() {
    return configStore.builderMode;
  }

  get activeElementId() {
    return uiStore.activeElementId;
  }

  @Prop()
  position!: PanelPosition;

  @Prop()
  panelState!: UIPanel | "closed";

  @Watch("panelState")
  updatePanelContext() {
    this.reactivePanelContext.state = this.panelState;
  }

  /**
   * @Provide isn't reactive without using state
   */
  reactivePanelContext = {
    state: this.panelState,
    position: this.position
  };

  @Provide("panelContext")
  panelContext = this.reactivePanelContext;
}

export type PanelContext = typeof SidebarPanels.prototype.panelContext;
